import type { Event } from '../types';

type Payload = { event_type: 'PageViewed' };

/**
 * Page view event for GWS-Flows.
 *
 * Uses eventCategory='Page' and eventName='Viewed' to generate schema:
 * buildCamel('Page', 'Viewed') → 'PageViewed' → 'pageViewed'.
 * Result: com.gusto/pageViewed/1 (matches ZP and is recognized by Amplitude pipeline).
 */
export class PageViewedEvent implements Event<Payload> {
  readonly payload: Payload = { event_type: 'PageViewed' };
  readonly eventCategory = 'Page';
  readonly eventName = 'Viewed';
  readonly rumActionName = 'PageViewed';
}
